import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, Button, DialogActions } from '@mui/material';
import GreenSelectButton from './greenSelectButton';
import GreenRow from './greenRow';
import { updateGreenSetup } from '../../features/event/eventSlice';

// Get Event Club/Venue
// Get Greens & Rinks from Club
// Have a grid of greens/rinks with a checkbox to select active true/false.
//
// club :{
//   greens : [{ green: "A", rink_count: 6 },{ green: "B", rink_count: 6 },{..}],

const GreenSetupDialog = ({ event }) => {
  const [open, setOpen] = React.useState(false);
  const [greens, setGreens] = React.useState([]);

  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
  };

  const getGreensFromVenue = React.useCallback(() => {
    // Get greens from the event's club/venue
    if (!event || !event.venue || !event.venue.greens) {
      return [];
    }

    const newGreensObject = [];
    for (let i = 0; i < event.venue.greens.length; i++) {
      const green = event.venue.greens[i];

      const rinks = [];
      for (let j = 1; j <= green.rink_count; j++) {
        rinks.push({
          rink: j,
          active: true
        });
      }

      newGreensObject.push({ name: green.name, rinks });
    }
    return newGreensObject;
  }, [event]);

  useEffect(() => {
    if (event) {
      if (event.venue && (!event.greens || event.greens?.length === 0)) {
        const fetchedGreens = getGreensFromVenue();
        setGreens(fetchedGreens);
      } else {
        setGreens(event.greens || []);
      }
    }
  }, [event, getGreensFromVenue]);

  const handleRinkToggle = (greenName, rinkNumber) => {
    setGreens((prevGreens) =>
      prevGreens.map((green) =>
        green.name === greenName
          ? {
              ...green,
              rinks: green.rinks.map((rink) =>
                rink.rink === rinkNumber ? { ...rink, active: !rink.active } : rink
              )
            }
          : green
      )
    );
  };

  const handleSave = () => {
    dispatch(updateGreenSetup({ eventId: event.id, greens }));
    setOpen(false);
  };

  return (
    event && (
      <>
        <Button color="success" variant="outlined" onClick={() => setOpen(true)}>
          Open Green Setup
        </Button>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Green Setup - {event?.venue?.name}</DialogTitle>
          <DialogContent>
            {greens.map((green, index) => (
              <GreenRow
                key={index}
                venue={event?.venue}
                green={green}
                onRinkToggle={(greenName, rinkNumber) => handleRinkToggle(greenName, rinkNumber)}
              />
            ))}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSave} color="primary" variant="contained">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </>
    )
  );
};

export default GreenSetupDialog;
